import { useEffect, useState } from "react";
import { api } from "../../services/apiService";

export function useTrens() {
  const [trens, setTrens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const carregarTrens = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.trem.getAll(1, 100);
        setTrens(response?.data?.items || []);
      } catch (error) {
        setTrens([]);
        setError("Erro ao carregar a lista de trens.");
      } finally {
        setLoading(false);
      }
    };

    carregarTrens();
  }, []);

  return { trens, loading, error };
}
